export const supportedLocales = ['en', 'es', 'fr'];
export const defaultLocale = 'en';
const englishCopy = {
    common: {
        cancel: 'Cancel',
        loading: 'Loading...',
        saving: 'Saving...',
        edit: 'Edit',
        approve: 'Approve',
        deny: 'Deny',
        free: 'Free',
        optional: 'optional',
        notSpecified: 'Not specified',
        noPriceSet: 'No price set',
    },
    status: {
        approved: 'approved',
        denied: 'denied',
        pending: 'pending',
        purchased: 'purchased',
        ready: 'ready',
        draft: 'draft',
    },
    errors: {
        unauthorized: 'Unauthorized',
        invalidRequest: 'Invalid request',
        stripeNotConfigured: 'Stripe is not configured',
        userEmailNotFound: 'User email not found',
        profileNotFound: 'Profile not found',
        referencePackNotAvailableForRequest: 'Reference pack not available for request',
        referencePackNotAvailableForPurchase: 'Reference pack not available for purchase',
        referencePackNoLongerAvailable: 'Sorry, this reference pack is no longer available.',
        referencePackCanBePurchasedDirectly: 'This reference pack can be purchased without an access request',
        alreadyHasReferencePackAccess: 'You already have access to this reference pack',
        accessRequestNotFoundOrReviewed: 'Access request not found or already reviewed',
        approvedPurchasePriceUnavailable: 'Approved purchase price is not available.',
        requestApprovalBeforePurchase: 'Request access and wait for the model to approve it before purchasing this pack.',
        failedToLoadAccessRequests: 'Failed to load access requests',
        failedToApproveAccessRequest: 'Failed to approve access request',
        failedToDenyAccessRequest: 'Failed to deny access request',
        failedToRequestAccess: 'Failed to request access',
        failedToCreateReferencePackPurchase: 'Failed to create reference pack purchase',
    },
    referencePacks: {
        editor: {
            whoCanBuy: 'Who can buy this reference pack',
            attendeesOnly: 'Attendees only',
            anyone: 'Anyone',
            requireApprovalTitle: 'Require approval before purchase',
            requireApprovalHelp: 'Buyers send a request first. You can approve, deny, or approve with a custom price before checkout is available.',
            showOnProfile: 'Show this pack on my profile',
        },
        summary: {
            sectionTitle: 'Reference Packs',
            noPacksPublished: 'No reference packs published yet.',
            includedRecordingsAccessible: 'You have access to the recordings included in your reference packs.',
            yourPacksAvailable: 'Your reference packs for this session are below.',
            modelReleasedPacks: 'The model has released reference packs for this session.',
            purchasedPacksAccessible: 'You have access to the reference packs below.',
            packsAvailable: 'Reference packs are available for this session.',
            noPacksAvailable: 'No reference packs are available yet.',
            approvalExplainer: '{modelName} has asked to approve requests first. You will receive a link to buy if the request is approved.',
            approvedFor: 'Approved for {price}. You can purchase this pack now.',
            requestPending: 'Request pending.',
            requestDeclined: 'Request declined.',
            requestDeclinedWithNote: 'Request declined: {note}',
            accessExpires: 'Access expires {date}.',
            purchased: 'Purchased',
            openReferencePack: 'Open reference pack.',
            openingCheckout: 'Opening checkout...',
            buyForPrice: 'Buy {price}',
            requestPendingButton: 'Request pending',
            requestAgainForPrice: 'Request again - {price}',
            requestAccessForPrice: 'Request - {price}',
            recordingsAndPhotos: '{recordingCount} {recordingLabel} - {photoCount} {photoLabel}',
            recordingSingular: 'recording',
            recordingPlural: 'recordings',
            photoSingular: 'photo',
            photoPlural: 'photos',
        },
        requestAccess: {
            modalTitle: 'Request access',
            modalBody: 'Sharing recordings and photos from life drawing sessions is a vulnerable thing for models to do. Tell the model how you plan to use the pack; if they approve, you can purchase it.',
            listedAt: 'Listed at {price}',
            intendedUseLabel: 'Intended use',
            intendedUsePlaceholder: 'Briefly describe how you intend to use this reference set.',
            requestedAccessUntilLabel: 'Requested access until',
            requestedAccessUntilHelp: 'The model can use this when deciding whether to approve the request.',
            sendRequest: 'Send request',
            sendingRequest: 'Sending request...',
            pendingAlert: 'Your request is pending. You will be notified when the model reviews it.',
            intendedUseRequiredAlert: 'Please describe how you plan to use this reference pack.',
            requestSentAlert: 'Request sent. You will be notified when the model reviews it.',
            failedToSendRequest: 'Failed to send request',
            failedToStartCheckout: 'Failed to start checkout',
        },
        modelQueue: {
            pageTitle: 'Reference Packs',
            heading: 'Access requests',
            empty: 'No access requests yet.',
            loading: 'Loading...',
            buyerFallback: 'A buyer',
            listedPrice: '{buyerName} - {roomName} - listed {price}',
            requestedAccessUntil: 'Requested access until {date}',
            approvedAt: 'Approved at {price}',
            declined: 'Declined',
            acceptedPrice: 'Accepted price',
            note: 'Note',
            notePlaceholder: 'Optional note for the buyer',
            enterApprovedPrice: 'Enter an approved price greater than zero.',
            failedToApprove: 'Failed to approve request',
            failedToDeny: 'Failed to deny request',
            publishedPacks: 'Published packs',
            noPublishedPacks: 'No reference packs yet.',
            shownOnProfile: 'Shown on profile',
            hiddenFromProfile: 'Hidden from profile',
        },
        email: {
            requestReceivedSubject: '{buyerName} requested "{productTitle}"',
            decisionApprovedSubject: '"{productTitle}" was approved for purchase',
            decisionDeniedSubject: '"{productTitle}" request was declined',
            requestHeader: 'Reference Pack',
            requestSentHeader: 'Request Sent',
            approvedHeader: 'Approved',
            declinedHeader: 'Declined',
            helloName: 'Hello {name},',
            requestReceivedTitle: '{buyerName} requested access to {productTitle}',
            listedAt: '{roomName} - listed at {price}',
            intendedUseLabel: 'Intended use',
            requestedAccessUntil: 'Requested access until: {date}',
            reviewRequest: 'Review Request',
            viewPack: 'View pack',
            approvedTitle: '{productTitle} was approved',
            declinedTitle: '{productTitle} was declined',
            approvedBody: '{modelName} approved your request. You can buy it for {price}.',
            declinedBody: '{modelName} declined your request.',
            purchasePack: 'Purchase Pack',
            textRequestReceived: '{buyerName} requested access to "{productTitle}".',
            textSession: 'Session: {roomName}',
            textListedPrice: 'Listed price: {price}',
            textRequestedAccessUntil: 'Requested access until: {date}',
            textIntendedUse: 'Intended use:',
            textReviewRequest: 'Review request: {url}',
            textViewPack: 'View pack: {url}',
            textApproved: '{modelName} approved your request for "{productTitle}".',
            textDeclined: '{modelName} declined your request for "{productTitle}".',
            textApprovedPrice: 'Approved price: {price}',
            textPurchase: 'Purchase: {url}',
            textNoteFromModel: 'Note from {modelName}:',
            footer: 'LifeDrawing.live',
        },
    },
};
const copyByLocale = {
    en: englishCopy,
    es: {},
    fr: {},
};
export function resolveLocale(locale) {
    if (!locale)
        return defaultLocale;
    const candidates = locale
        .split(',')
        .map((part) => part.trim().split(';')[0]?.toLowerCase())
        .filter(Boolean);
    for (const candidate of candidates) {
        const baseLanguage = candidate.split('-')[0];
        if (supportedLocales.includes(baseLanguage)) {
            return baseLanguage;
        }
    }
    return defaultLocale;
}
export function getCopy(locale, key) {
    const resolvedLocale = resolveLocale(locale);
    const localizedValue = lookup(copyByLocale[resolvedLocale], key);
    if (typeof localizedValue === 'string')
        return localizedValue;
    const englishValue = lookup(englishCopy, key);
    if (typeof englishValue === 'string')
        return englishValue;
    return `[missing copy: ${key}]`;
}
export function t(locale, key, params) {
    return interpolate(getCopy(locale, key), params);
}
export function createCopy(locale) {
    const resolvedLocale = resolveLocale(locale);
    return {
        locale: resolvedLocale,
        t: (key, params) => t(resolvedLocale, key, params),
    };
}
function lookup(source, key) {
    return key.split('.').reduce((current, segment) => {
        if (!current || typeof current !== 'object')
            return undefined;
        return current[segment];
    }, source);
}
function interpolate(template, params) {
    if (!params)
        return template;
    return template.replace(/\{(\w+)\}/g, (_, key) => {
        const value = params[key];
        return value === null || value === undefined ? '' : String(value);
    });
}
//# sourceMappingURL=copy.js.map